import 'flatpickr/dist/themes/airbnb.css'
import { Field, useFormikContext } from 'formik'
import Flatpickr from 'react-flatpickr'
import { useIntl } from 'react-intl'
import SideCardImg from '../assets/side-card.png'
import { ValidSchema } from '../context/validForm'
import { useMerchantData } from '../hook'
import moment from 'moment'

export default function FormStarted({
  errors,
  touched,
}: {
  errors?: any
  touched?: any
  list?: { countries: any[]; cities: any[]; regions: any[] }
  changeCountry?: (countryId: string) => void
  changeCity?: (cityId: string) => void
}) {
  const intl = useIntl()
  const { values, setFieldValue } = useFormikContext<ValidSchema>()
  const { merchantData } = useMerchantData()

  return (
    <div className='card bg-light'>
      <div className='d-flex align-items-center'>
        <div className='card-body w-75'>
          <h2 className='fs-1 py-4 w-100 fw-bold text-primary mb-1'>
            {intl.formatMessage({ id: 'AUTH.BECOME_MEMBER.FORM' })}
          </h2>
          <p className='fs-5 fw-bold mb-10'>
            {intl.formatMessage({ id: 'AUTH.BECOME_MEMBER.FORM_DESC' })}
          </p>
          <div className='row d-flex align-items-center'>
            <div className='col-8'>
              <div className='row'>
                <div className='col-6'>
                  <label className='required form-label'>
                    {/*  {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.MERCHANT_TRADE_NAME'})} */}
                    Merchant ID
                  </label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='text'
                      className='form-control'
                      id='merchantID'
                      name='merchantID'
                      placeholder=''
                      disabled
                    />
                    <label>
                      {/*   {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.MERCHANT_TRADE_NAME'})} */}
                      Merchant ID
                    </label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.merchantID && touched.merchantID && (
                      <div className='fv-help-block'>{errors.merchantID}</div>
                    )}
                  </div>
                </div>
                <div className='col-6'>
                  <label className='required form-label'>
                    {/*  {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.MERCHANT_TRADE_NAME'})} */}
                    Merchant Name
                  </label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='text'
                      className='form-control'
                      name='merchantName'
                      id='merchantName'
                      placeholder=''
                      disabled
                    />
                    <label>
                      {/*   {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.MERCHANT_TRADE_NAME'})} */}
                      Merchant Name
                    </label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.merchantName && touched.merchantName && (
                      <div className='fv-help-block'>{errors.merchantName}</div>
                    )}
                  </div>
                </div>

                <div className='col-6'>
                  <label className='required form-label'>
                    {/*   {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.EMAIL_ADDRESS'})} */}
                    Merchant Email
                  </label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='email'
                      className='form-control'
                      id='merchantEmail'
                      name='merchantEmail'
                      placeholder='name@example.com'
                      disabled
                    ></Field>
                    <label>
                      {/* {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.EMAIL_ADDRESS'})} */}
                      Merchant Email
                    </label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.merchantEmail && touched.merchantEmail && (
                      <div className='fv-help-block'>{errors.merchantEmail}</div>
                    )}
                  </div>
                </div>

                <div className='col-6'>
                  <label className='required form-label'>
                    {/* {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.BUSINESS_NAME'})} */}
                    Merchant Service Provider
                  </label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='text'
                      className='form-control'
                      id='isoName'
                      name='isoName'
                      placeholder=''
                      disabled
                    />
                    <label>
                      {/* {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.BUSINESS_NAME'})} */}
                      Merchant Service Provider
                    </label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.isoName && touched.isoName && (
                      <div className='fv-help-block'>{errors.isoName}</div>
                    )}
                  </div>
                </div>

                <div className='col-6'>
                  <label className='required form-label'>
                    {/* {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.BUSINESS_NAME'})} */}
                    Merchant Service Provider ID
                  </label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='text'
                      className='form-control'
                      name='isoid'
                      id='isoid'
                      placeholder=''
                      disabled
                    />
                    <label>
                      {/* {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.BUSINESS_NAME'})} */}
                      Merchant Service Provider ID
                    </label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.isoid && touched.isoid && (
                      <div className='fv-help-block'>{errors.isoid}</div>
                    )}
                  </div>
                </div>

                <div className='col-6'>
                  <label className='required form-label'>
                    {/* {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.BUSINESS_NAME'})} */}
                    Update Date & Time
                  </label>
                  <div className='fv-row mb-4 form-floating'>
                    <Flatpickr
                      className='form-control'
                      options={{
                        enableTime: true,
                        dateFormat: 'Y-m-d H:i',
                      }}
                      placeholder='YYYY-MM-DD HH:MM'
                      name='updateDateAndTime'
                      id='updateDateAndTime'
                      value={moment(values.updateDateAndTime).format('YYYY-MM-DD HH:mm')}
                      onChange={(date) => setFieldValue('updateDateAndTime', date)}
                      disabled
                    />
                    <label>
                      {/* {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.BUSINESS_NAME'})} */}
                      Update Date & Time
                    </label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.updateDateAndTime && touched.updateDateAndTime && (
                      <div className='fv-help-block'>{errors.updateDateAndTime}</div>
                    )}
                  </div>
                </div>

                <div className='col-12 mt-6 pt-6' style={{ borderTop: '1px solid #e0e0e0' }}>
                  <h2 className='fs-2 fw-bold text-primary mb-1'>Primary Contact</h2>
                  <p className='fs-5 fw-bold mb-10'>Enter your primary contact details</p>
                </div>

                <div className='col-6'>
                  <label className='required form-label'>Name</label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='text'
                      className='form-control'
                      name='name'
                      id='name'
                      placeholder=''
                    />
                    <label>Name</label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.name && touched.name && (
                      <div className='fv-help-block'>{errors.name}</div>
                    )}
                  </div>
                </div>

                <div className='col-6'>
                  <label className='required form-label'>Last Name</label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='text'
                      className='form-control'
                      name='surname'
                      id='surname'
                      placeholder=''
                    />
                    <label>Last Name</label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.surname && touched.surname && (
                      <div className='fv-help-block'>{errors.surname}</div>
                    )}
                  </div>
                </div>

                <div className='col-6'>
                  <label className='required form-label'>Email</label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='text'
                      className='form-control'
                      name='email'
                      id='email'
                      placeholder=''
                    />
                    <label>Email</label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.email && touched.email && (
                      <div className='fv-help-block'>{errors.email}</div>
                    )}
                  </div>
                </div>

                <div className='col-6'>
                  <label className='required form-label'>Phone</label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='text'
                      className='form-control'
                      name='phone'
                      id='phone'
                      placeholder=''
                    />
                    <label>Phone</label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.phone && touched.phone && (
                      <div className='fv-help-block'>{errors.phone}</div>
                    )}
                  </div>
                </div>

                <div className='col-6'>
                  <label className='required form-label'>Title</label>
                  <div className='fv-row mb-4 form-floating'>
                    <Field
                      type='text'
                      className='form-control'
                      name='title'
                      id='title'
                      placeholder=''
                    />
                    <label>Title</label>
                  </div>
                  <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                    {errors.title && touched.title && (
                      <div className='fv-help-block'>{errors.title}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='col-4'>
              <div
                className='card h-350px d-flex justify-content-center align-items-center'
                style={{
                  backgroundColor: '#2b3e47',
                }}
              >
                <div
                  className='rounded w-100 h-100 bgi-no-repeat bgi-position-center bgi-size-contain'
                  style={{
                    backgroundImage: `url(${SideCardImg})`,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row w-100 d-flex justify-content-center align-items-center mb-10'>
        <button className='btn btn-primary btn-lg fs-2 w-25' type='submit'>
          {intl.formatMessage({ id: 'GLOBAL.BUTTON.NEXT' })}
        </button>
      </div>
    </div>
  )
}
